import { FormFieldContainer } from '@ingenico/react-ui/form-field-container';
import { AutocompleteControl } from '@ingenico/react-ui/form-section';
import { toString } from 'lodash-es';
import type { ReactNode } from 'react';
import { Controller } from 'react-hook-form';
import type { FileOutputFormularyModalSchema } from '../../useFileOutputFormularyModal.hook';
import type { SelectorFieldProps } from './SelectorField.model';

export function SelectorField<FieldName extends keyof FileOutputFormularyModalSchema>({
  control,
  dataErrorTestId,
  dataTestId,
  fieldName,
  getOptionLabel,
  inputLabel,
  isDisabled,
  isLoading,
  isOptionEqualToValue,
  isReadOnly,
  onChangeTrigger,
  onInputChange,
  options,
  renderOption,
  inputValue,
}: SelectorFieldProps<FieldName>): ReactNode {
  return (
    <Controller
      control={control}
      name={fieldName}
      render={({ field: { value, name, onChange }, fieldState }) => {
        return (
          <FormFieldContainer>
            <AutocompleteControl
              filterSelectedOptions={false}
              defaultValue={undefined}
              disabled={isDisabled}
              error={fieldState.invalid}
              formHelperTextProps={{
                id: dataErrorTestId,
              }}
              getOptionLabel={getOptionLabel}
              helperText={fieldState.error?.message}
              input={{
                label: inputLabel,
                name,
                component: 'Autocomplete',
              }}
              inputProps={{
                'data-testid': dataTestId,
              }}
              inputValue={inputValue}
              isOptionEqualToValue={isOptionEqualToValue}
              loading={isLoading}
              onChange={
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                ((__, onChangeValue: any) => {
                  onChange(toString(onChangeValue));
                  onChangeTrigger?.(onChangeValue);
                  // eslint-disable-next-line @typescript-eslint/no-explicit-any
                }) as any
              }
              onInputChange={onInputChange}
              options={options}
              readOnly={isReadOnly}
              renderOption={renderOption}
              required={!isReadOnly}
              value={value}
            />
          </FormFieldContainer>
        );
      }}
    />
  );
}
